import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/authContext";
import СoveredBackground from "../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../UI/ErrorMessage/ErrorMessage";
import Loader from "../UI/Loader/Loader";
import SuccessMessage from "../UI/SuccessMessage/SuccessMessage";
import MainNotify from "../UI/Notification/MainNotify/MainNotify";
import { Link } from "react-router-dom";
import FormElement from '../components/FormInput/FromElement'


const RegPage = () => {
  const [pharmacies, setPharmacies] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { regGet, loading, reg } = useContext(AuthContext);

  const uploadPharmacies = async () => {
    const res = await regGet();
    setPharmacies(res.data);
  };

  const defaultInputs = {
    iin: "",
    surname: "",
    name: "",
    num_ap: "",
  };
  const [inputs, setInputs] = useState(defaultInputs);


  useEffect(() => {
    document.title = "Регистрация"
    uploadPharmacies();

    setInputs((prev) => ({ ...prev, num_ap: "1" }));
  }, []);

  const handleChange = async (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const submitHandler = async (e) => {
    try {
      e.preventDefault();
      const res = await reg(inputs);
      setSuccess(res.data);
      setInputs(defaultInputs);
      setError(null);
      //   navigate("/", {replace: true});
    } catch (err) {
      setError(err.response.data.error);
      if (success) setSuccess(null);
    }
  };

  const closeNotify = () => {
    setSuccess(null);
  };

  return (
    <>
      {success && (
        <MainNotify
          title={success}
          close={closeNotify}
          descr={
            <Link to="/login" className="btn_continue" onClick={closeNotify}>
              Авторизоваться
            </Link>
          }
        />
      )}
      <section className="reg">
        <div className="container">
          <h1 className="reg__text">Заполните форму регистрации</h1>

          <div className="reg__wrapper">
            {loading && (
              <СoveredBackground>
                <Loader />
              </СoveredBackground>
            )}
            {error && <ErrorMessage message={error} />}
            {success && <SuccessMessage message={success}></SuccessMessage>}

            <form className="reg__form" onSubmit={submitHandler}>

              <FormElement
                nameId="iin"
                label="Введите ИИН:"
                placeholder="ИИН"
                value={inputs.iin}
                maxLength={12}
                minLength={12}
                onChange={handleChange}
              />

              <FormElement
                  nameId="num_ap"
                  label="Выберите номер аптеки:"
                  onChange={handleChange}
                  typeInput="select"
                  pharmacies={pharmacies}
              />
              
              <FormElement
                nameId="name"
                label="Введите имя:"
                placeholder="Имя"
                value={inputs.name}
                maxLength={15}
                minLength={2}
                onChange={handleChange}
              />

              <FormElement
                nameId="surname"
                label="Введите фамилию:"
                placeholder="Фамилия"
                value={inputs.surname}
                maxLength={25}
                minLength={2}
                onChange={handleChange}
              />
              <button className="reg__wrapper__link">Регистрация</button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default RegPage;
